import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import SignupForm from "../components/SignupForm/SignupForm"
import Footer from "../components/Footer/Footer"

function Signup() {
  return (
    <>
<Navbar/>
<SignupForm/>
<Footer/>
    </>  )
}

export default Signup